<template>
  <div>
    <div v-if='showSpinner' class='loader-wrapper'>
      <div class='loader'></div>
    </div>
    <deal-information
      v-bind:type="'bond'"
      :shownTypes="['STACR', 'CAS', 'ILN']"
      :validDeal.sync='validDeal'
      path='bond_analysis'
      v-bind:inputError='inputError'
      :report1='report1'
      @dealNameChange='dealName = $event'
      @bondNameChange='onBondNameChange'
      @settlementDateChange='settlementDate = $event'
      @cprChange='cpr = $event'
      @cdrChange='cdr = $event'
      @lossSeverityChange='lossSeverity = $event'
      @delinquencyChange='delinquency = $event'
      @liborChange='libor = $event'
      @hpiChange='hpi = $event'
      @NationalUnemploymentForecastChange='NationalUnemploymentForecast = $event'
      @hpaChange='hpa = $event'
      @2YrTsyChange='twoYrTsy = $event'
      @10YrTsyChange='tenYrTsy = $event'
      @tuneCprChange='tuneCpr = $event'
      @tuneCdrChange='tuneCdr = $event'
      @tuneSeverityChange='tuneSeverity = $event'
      @mtg15Change='mtg15Yr = $event'
      @mtg30Change='mtg30Yr = $event'
      @useLoanLevelChange='onUseLoanLevelChanged'
      @show-spinner='showSpinner = true'
      @hide-spinner='showSpinner = false'
      @scenarioChange='selectedScenario = $event'
    />
    <!-- <bond-remit-history v-if="dealName.startsWith('STACR')"
        :history="bondRemitHistory"
        @load="loadBondRemitHistory"/> -->
    <bond-pricing
      v-if='validDeal'
      v-bind:dealName='dealName'
      v-bind:bondName='bondName'
      v-bind:settlementDate='settlementDate'
      v-bind:cpr='cpr'
      v-bind:cdr='cdr'
      v-bind:lossSeverity='lossSeverity'
      v-bind:delinquency='delinquency'
      v-bind:libor='libor'
      :hpi='hpi'
      :NationalUnemploymentForecast='NationalUnemploymentForecast'
      :hpa='hpa'
      :twoYrTsy='twoYrTsy'
      :tenYrTsy='tenYrTsy'
      v-bind:tuneCpr='tuneCpr'
      v-bind:tuneCdr='tuneCdr'
      v-bind:tuneSeverity='tuneSeverity'
      :mtg15Yr='mtg15Yr'
      :mtg30Yr='mtg30Yr'
      :useLoanLevel='useLoanLevel'
      :selectedScenario='selectedScenario'
      @inputError='inputError = $event'
      @show-spinner='showSpinner = true'
      @hide-spinner='showSpinner = false'
    />
<!--
    <reportSingleExecutor
      :pReportName='ReportsNames.Historical.BOND'
      :pReportParams='[
            {
              "DbName": "deal",
              "Value": $route.query.dealName
            }
        ]'
    />
-->
  </div>
</template>

<script>
import service              from '../../services/HttpRequestService';
import DealInformation      from '../dealInformation/';
import BondPricing          from './BondPricing';
import BondRemitHistory     from './BondRemitHistory';
import formatter            from '../../utilities/Formatter';
import reportSingleExecutor from '@/components/common/reportSingleExecutor';
import ReportsNames         from '@/constants/reportsNames';

export default {
  data() {
    return {
      dealName: '',
      bondName: '',
      settlementDate: {},
      cpr: [0],
      cdr: [0],
      lossSeverity: [0],
      delinquency: [0],
      libor: [0],
      hpi: [],
      NationalUnemploymentForecast: [],
      hpa: [],
      twoYrTsy: '',
      tenYrTsy: '',
      tuneCpr: [0],
      tuneCdr: [0],
      tuneSeverity: [0],
      mtg15Yr: [0],
      mtg30Yr: [0],
      selectedScenario: null,
      inputError: '',
      showSpinner: false,
      validDeal: false,
      useLoanLevel: this.$store.getters.useLoanLevel || false,
      bondRemitHistory: [],
      ReportsNames
    };
  },
  computed: {
    report1() {
      return {
        pReportName: ReportsNames.Historical.BOND,
        pReportParams: [
          {
            'DbName': 'deal',
            'Value': this.$route.query.dealName
          }
        ],
        flagShowOwnRunButton: false,
        pLabelRunButton: `Run ${ReportsNames.Historical.BOND} Report`
        //triggerRunReport:     false, // SHOULD BE DEFINED IN CHILD DATA
      };
    }
  },
  methods: {
    onUseLoanLevelChanged() {
      this.$store.commit('useLoanLevelChanged', !this.useLoanLevel);
    },
    onBondNameChange(bondName) {
      this.bondName = bondName;
      this.bondRemitHistory = [];
    },
    async loadBondRemitHistory() {
      this.showSpinner = true;
      let res = await service.getBondRemitHistory(this.dealName, this.bondName);
      this.bondRemitHistory = formatter.formatDataInArray(res.data.BondRemitHistory,
        ['StartingBalance', 'Principal', 'Interest', 'WriteDown', 'CurrentBalance'], ['Date'], ['Coupon'], ['Factor']);
      this.showSpinner = false;
    }
  },
  components: {
    DealInformation,
    BondPricing,
    BondRemitHistory,
    reportSingleExecutor
  }
};
</script>
